import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";
import { IntegrationStatus } from "../models";

// auto trigger
export const useIntegrationsStatus = ({
    companyId,
    locationId,
}: {
    companyId?: string;
    locationId?: string;
}) => {
    const { data, isLoading } = useSWR(
        companyId && locationId
            ? `/api/integrations-routing/v1/companies/${companyId}/locations/${locationId}/status`
            : null
    );

    return {
        integrationsStatus: data as IntegrationStatus,
        isLoadingIntegrationsStatus: isLoading,
    };
};

// manual trigger with mutation
export const useGetIntegrationsStatus = ({
    companyId,
    locationId,
}: {
    companyId?: string;
    locationId?: string;
}) => {
    const {
        trigger: triggerGetIntegrationsStatus,
        isMutating: isMutatingGetIntegrationsStatus,
    } = useSWRMutation(
        `/api/integrations-routing/v1/companies/${companyId}/locations/${locationId}/status`,
        (
            url: string,
            {
                arg,
            }: {
                arg: { companyId?: string; locationId?: string };
            }
        ) =>
            fetcher(
                arg.companyId && arg.locationId
                    ? `/api/integrations-routing/v1/companies/${arg.companyId}/locations/${arg.locationId}/status`
                    : url,
                {
                    options: {
                        method: API_REST_METHODS.GET,
                    },
                }
            )
    );

    return {
        triggerGetIntegrationsStatus,
        isMutatingGetIntegrationsStatus,
    };
};
